module.exports = __webpack_public_path__ + "img/preview.fc679d75.png";